import type { ReactNode } from "react";
import { View } from "react-native";

import { Text } from "@/ui/Text";

import { useScreenStyles } from "./screenStyles";

type Props = {
  title: string;
  /** testID, e.g. `placeholder-home`. */
  testID: string;
  /** 006 (FR-004): replaces "Coming in a later feature". */
  message?: string;
  children?: ReactNode;
};

/** A section placeholder until its feature lands (FR-003): the title and "Coming in a later feature". */
export function PlaceholderScreen({
  title,
  testID,
  message = "Coming in a later feature",
  children,
}: Props) {
  const styles = useScreenStyles();
  return (
    <View style={styles.screen} testID={testID} role="main">
      <View style={styles.body}>
        <Text variant="heading" accessibilityRole="header" aria-level={1}>
          {title}
        </Text>
        <Text tone="muted" style={styles.message}>
          {message}
        </Text>
        {children}
      </View>
    </View>
  );
}
